import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {IUserDetails} from '@irb/app.model';
import {MainMenuService} from "@irb-common/modules/main-menu/main-menu.service";
import { AppService } from '@irb/app.service';

@Injectable({
    providedIn: 'root'
})
export class IrbRouteAuthorizationAccessGuard implements CanActivate {
    constructor(private router: Router, private mainMenuService: MainMenuService, private as: AppService) {
    }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const config: IUserDetails = this.as.getItem('IRB_APP_CONFIG');
        if (window.sessionStorage.getItem('IRB_AUTH_TOKEN') && config) {
            let hasAccessToRoute = this.hasAccess(state);
            return hasAccessToRoute;
        }
        return false;
    }

    private hasAccess(state: RouterStateSnapshot) {
        let flattenedRoutes = this.mainMenuService.flattenedRoutes;
        if (flattenedRoutes && flattenedRoutes.length > 0) {
             let routeToNavigate = flattenedRoutes.find((x: any)=> state.url.toLowerCase().includes(x.routerLink.toLowerCase()));
             if(routeToNavigate) {
                 let isDisabled = (routeToNavigate.disabled !== undefined && routeToNavigate.disabled === true)? true: false;
                 return !isDisabled;

             } else {
                 return true;
             }
        } else {
            return true;
        }
    }

}
